'use client'

import _ from 'lodash'
import { useEffect, useState } from 'react'
import { redirect } from 'next/navigation'
import FacebookLogin from '@greatsumini/react-facebook-login'
import { Button } from '@/components'
import { authApi } from '@/api'
import { useGlobalStore } from '@/store/provider'
import { facebookAppId, pages } from '@/settings'
import { Auth } from '@/types/auth'

// https://medium.com/@syedmahmad/login-with-facebook-meta-in-react-app-88efb7a9fc0a

export function SignInWithFacebook({ afterSignIn }: Auth.SignInProps) {
  const { user, setUser } = useGlobalStore((state) => state)
  const [isWorking, setIsWorking] = useState(false)
  const [token, setToken] = useState<string | null | any>(null)

  async function signIn() {
    setIsWorking(true)
    try {
      const d = await authApi.signInWithFacebook({ token })
      setUser(d.data, null)
    } catch {
      setIsWorking(false)
    }
  }

  useEffect(() => {
    if (_.isEmpty(user) || !isWorking) return
    setIsWorking(false)
    if (afterSignIn) {
      afterSignIn()
    } else {
      redirect(pages.myProfile.href)
    }
  }, [user?._id])

  useEffect(() => {
    if (!token) return
    setIsWorking(true)
    signIn()
  }, [token])

  return (
    <FacebookLogin
      appId={facebookAppId}
      onSuccess={res => {
        setToken(res.accessToken)
      }}
      render={({ onClick }) => (
        <Button type='button' variant='outline' className='btn-signin' onClick={onClick} working={isWorking}>
          <img src='/img/facebook-logo-128.png' className='w-5 mr-3' />
          Sign in with Facebook
        </Button>
      )}
    />

  )
}